import React from 'react';
import { Button } from './ui/button';
/** A failed module download must not strand a newly signed-in user on a blank page. */
export default class WorkspaceLoadingBoundary extends React.Component<{children: React.ReactNode}, {failed: boolean}> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="foundation-page shadcn-scope"><h1>Could not open the app</h1><p role="alert">Check your connection, then reload to try again. Records already saved on this device are kept.</p><Button onClick={() => window.location.reload()}>Reload app</Button></main>;
  }
}
